/**
 * Which Habits view a phone opens: "Today" (one check-in target per habit) or
 * the "Week grid". A per-device choice kept in localStorage; storage can be
 * missing or throw (private windows, blocked site data), so every access is
 * guarded and the page works without it.
 */
export type HabitsMode = 'today' | 'grid';

export const HABITS_MODE_KEY = 'habits:mode';

/** Phones open in Today until the user picks otherwise. */
export const DEFAULT_HABITS_MODE: HabitsMode = 'today';

export function readHabitsMode(): HabitsMode | null {
  try {
    const value = localStorage.getItem(HABITS_MODE_KEY);
    return value === 'today' || value === 'grid' ? value : null;
  } catch {
    return null;
  }
}

export function saveHabitsMode(mode: HabitsMode) {
  try {
    localStorage.setItem(HABITS_MODE_KEY, mode);
  } catch {
    // Storage unavailable: the choice just lasts until the page is closed.
  }
}
